import React, { useEffect, useState } from 'react';
import { Col, Form, FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import ValidatedInput from "../../../components/ValidatedInput";
import { resetFlags, getGoogleContacts, referFriend } from "../../../redux/actions/AccountAction";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import AddContactModal from './AddContactModal';
import ListContactModal from './ListContactModal';
import EmailPreviewModal from './EmailPreviewModal';

const ReferFriend = ({
  accountFlags,
  accountErrors,
  resetFlags,
  history,
  handleSubmit,
  getGoogleContacts,
  referFriend }) => {
  const [processing, setProcessing] = useState(false);
  const [addContactModal, setAddContactModal] = useState(false);
  const [listContactModal, setListContactModal] = useState(false);
  const [emailPreviewModal, setEmailPreviewModal] = useState(false);

  const toggleAddContactModal = () => setAddContactModal(!addContactModal);
  const toggleEmailPreviewModal = () => setEmailPreviewModal(!emailPreviewModal);

  useEffect(() => {
      setInterval(() => {
          let step =localStorage.getItem('navigation');
          if(step !== ""){
              history.push('/add-account');
          }
      }, 500);
    if (accountErrors && accountErrors.getGoogleContacts) {
      toast.error(accountErrors.getGoogleContacts);
      setProcessing(false);
      resetFlags();
    }

    if (accountFlags && accountFlags.getGoogleContactsSuccess) {
      resetFlags();
      setListContactModal(true);
    }

    if (accountErrors && accountErrors.referFriend) {
      toast.error(accountErrors.referFriend);
      setProcessing(false);
      resetFlags();
    }

    if (accountFlags && accountFlags.referFriendSuccess) {
      setProcessing(false);
      resetFlags();
      history.push('/verified?accountType=Individual');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountErrors, accountFlags]);

  const skipAndNext = () => {
    history.push('/verified?accountType=Individual');
  }

  const onContactModalClosed = (accessToken) => {
    setAddContactModal(false);
    if (accessToken) {
      getGoogleContacts({ access_token: accessToken });
    }
  };

  const onListContactModalClosed = () => {
    setListContactModal(false);
  };

  const onEmailPreviewModalClosed = () => {
    setEmailPreviewModal(false);
  }

  const handleReferFriend = (formData) => {
    setProcessing(true);
    referFriend({ refer_list: [formData] });
  };

  return (
    <div className="account-setup-wrapper">
      <AddContactModal openModal={addContactModal} onClosed={onContactModalClosed} />
      <ListContactModal openModal={listContactModal} onClosed={onListContactModalClosed} />
      <EmailPreviewModal openModal={emailPreviewModal} onClosed={onEmailPreviewModalClosed} />
      <Form className="form-container" onSubmit={handleSubmit(handleReferFriend)}>
        <div className="form-header mt-md-3 mt-0">
          <h2>REFER A FRIEND</h2>
          <span>Get rewarded for referring your friends!</span>
        </div>

        <div className="account-info-container">
          <FormGroup className="row">
            <div className="col-sm-4 offset-sm-8">
              <button type="button" className="custom-btn-primary" onClick={toggleAddContactModal}>
                Sync Contacts <FontAwesomeIcon id="sync-contact-tooltip" icon={faQuestionCircle} />
              </button>
              <UncontrolledTooltip innerClassName="text-left fs12" placement="right" target="sync-contact-tooltip">
                This feature will upload your address book to MYRA's servers including detailed contact information
                 for all of your contacts. We will use this information to enable you to easily invite your contacts to join MYRA.
                 We will not email or invite any of your contacts without your permission.
              </UncontrolledTooltip>
              <button className="btn btn-link fs12" type="button" onClick={toggleEmailPreviewModal}>
                Preview Email Invite</button>
            </div>
          </FormGroup>
          <FormGroup row>
            <Label sm={5}>First Name</Label>
            <Col sm={7}>
              <Field
                component={ValidatedInput}
                type="text"
                name="first_name"
                placeholder="First Name" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={5}>Last Name</Label>
            <Col sm={7}>
              <Field
                component={ValidatedInput}
                type="text"
                name="last_name"
                placeholder="Last Name" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={5}>Email Address</Label>
            <Col sm={7}>
              <Field
                component={ValidatedInput}
                type="email"
                name="email"
                placeholder="Email Address" />
            </Col>
          </FormGroup>
        </div>
        <div className="button_wrapper">
          <button className="btn button" type="submit" disabled={processing}>
            SUBMIT {processing && <FontAwesomeIcon icon={faSpinner} spin />}
          </button>
        </div>
        <div className="links-forgot">
          <a href="#/" onClick={skipAndNext}>Skip now, I'll refer my friends later</a>
        </div>
      </Form>
    </div>
  )
};

const validate = (values) => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = 'Field is required';
  }
  if (!values.last_name) {
    errors.last_name = 'Field is required';
  }
  if (!values.email) {
    errors.email = 'Field is required';
  }
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }
  return errors;
};

const mapStateToProps = state => ({
  accountErrors: state.Account.errors,
  accountFlags: state.Account.flags,
});

const mapDispatchToProps = dispatch => ({
  resetFlags: () => {
    dispatch(resetFlags())
  },
  referFriend: payload => {
    dispatch(referFriend(payload))
  },
  getGoogleContacts: payload => {
    dispatch(getGoogleContacts(payload))
  }
});

const ReferFriendComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferFriend);

export default reduxForm({
  form: 'ReferFriendForm',
  validate,
})(ReferFriendComponent);
